import { getApiBaseUrl } from "../config/api";

const KEY = "at_admin_session";

export function saveAdminSession({ token, email, name, rememberMe, exp }) {
  const payload = JSON.stringify({
    token,
    email,
    name: String(name || "").trim(),
    rememberMe: Boolean(rememberMe),
    exp: Number(exp) || 0,
  });
  sessionStorage.removeItem(KEY);
  localStorage.removeItem(KEY);
  if (rememberMe) localStorage.setItem(KEY, payload);
  else sessionStorage.setItem(KEY, payload);
}

export function getAdminSession() {
  const raw = localStorage.getItem(KEY) || sessionStorage.getItem(KEY);
  if (!raw) return null;
  try {
    const data = JSON.parse(raw);
    const now = Math.floor(Date.now() / 1000);
    if (!data.token || !data.exp || data.exp < now) {
      clearAdminSession();
      return null;
    }
    return data;
  } catch {
    clearAdminSession();
    return null;
  }
}

export function clearAdminSession() {
  localStorage.removeItem(KEY);
  sessionStorage.removeItem(KEY);
}

export function logoutAdmin() {
  clearAdminSession();
}

export async function loginAdminRequest({ email, password, rememberMe }) {
  const res = await fetch(`${getApiBaseUrl()}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ email, password, rememberMe }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || "Unable to sign in");
  }
  return data;
}

export async function adminJson(path, { method = "GET", body } = {}) {
  const session = getAdminSession();
  const headers = { Accept: "application/json" };
  if (session?.token) headers.Authorization = `Bearer ${session.token}`;
  if (body !== undefined) headers["Content-Type"] = "application/json";
  const res = await fetch(`${getApiBaseUrl()}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (res.status === 401) {
    clearAdminSession();
    const err = new Error("Unauthorized");
    err.status = 401;
    throw err;
  }
  if (!res.ok) {
    throw new Error(data.message || "Request failed");
  }
  return data;
}
